export const ERROR_MESSAGES = {
  INVALID_USER_MESSAGE: 'Invalid User!',
  INVALID_ACCOUNT_MESSAGE: 'Account Id not found',
}

export const ERROR_EXCEPTIONS = {
  INVALID_USER_EXCEPTION: 'InvalidUserException',
  INVALID_ACCOUNT_EXCEPTION: 'InvalidAccountException',
}
